import { create } from 'zustand'
import { getObraConfig, saveObraConfig, hasOnboarded } from '@services/crud.js'
import type { ObraConfig } from '@services/db.js'

interface ObraState {
  config: ObraConfig | null
  isLoaded: boolean
  isOnboarded: boolean
  load: () => Promise<void>
  save: (data: Omit<ObraConfig, 'id' | 'criadoEm' | 'atualizadoEm'>) => Promise<void>
}

export const useObraStore = create<ObraState>((set, _get) => ({
  config: null,
  isLoaded: false,
  isOnboarded: false,

  load: async () => {
    try {
      const [config, onboarded] = await Promise.all([getObraConfig(), hasOnboarded()])
      set({ config: config ?? null, isLoaded: true, isOnboarded: onboarded })
    } catch (err) {
      console.error('Falha ao carregar obra:', err)
      set({ config: null, isLoaded: true, isOnboarded: false })
    }
  },

  save: async (data) => {
    await saveObraConfig(data)
    const config = await getObraConfig()
    set({ config: config ?? null, isOnboarded: true })
  },
}))
